// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1NfI5","productName":"Table_productName__1xpgb"};